import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectTemplateStepOptions } from './components/SelectTemplateStepOptions';
import { useAppStore } from 'stores/state';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/flow';

export const SelectTemplateStep: FC = () => {
  const { t } = useTranslation();

  const templateSlug = useAppStore((state) => state.templateSlug);

  return (
    <StepLayout
      title={t('select-template-step.title')}
      description={t('select-template-step.description')}
      nextButtonProps={{ label: t('select-template-step.actions.next-button'), disabled: !templateSlug }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectTemplate],
          action: BI_ACTION_NAME.NEXT,
          value: templateSlug,
        });
      }}
    >
      <SelectTemplateStepOptions />
    </StepLayout>
  );
};
